<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save()"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
    :loadingContent="loading"
    :showConfirmButton="!loading"
  >
    <div>
      <v-row>
        <v-col cols="2" align-self="center">
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text small v-bind="attrs" v-on="on" color="blue">
                <v-icon large>mdi-folder-table-outline</v-icon>
              </v-btn>
            </template>
            <v-list max-height="500" class="overflow-y-auto">
              <v-list-item
                v-for="(item, i) in fieldList"
                :key="i"
                @click="appendField(item)"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="2" align-self="center">
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text small v-bind="attrs" v-on="on" color="blue-grey">
                <v-icon large>mdi-folder-star-outline</v-icon>
              </v-btn>
            </template>
            <v-list max-height="500" class="overflow-y-auto">
              <v-list-item
                v-for="(item, i) in defaultOperators"
                :key="i"
                @click="appendOperator(item)"
              >
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col align-self="center">
          <v-textarea v-model="mask" auto-grow solo></v-textarea>
        </v-col>
      </v-row>
    </div>
  </base-modal>
</template>
<script>
import ContentTypeService from '@/services/ContentTypeService';
import ContentTypeField from '@/ecm/models/contentType/ContentTypeField';
export default {
    name: 'ExportConfigMaskModal',
    data() {
        return {
            modal: {
                title: this.$t('ExportMask'),
                key: 'exportConfigMaskModal',
            },
            open: false,
            mask: '',
            defaultOperators: [
                '@ID',
                '@LINENUMBER',
                '@URL',
                '@AUTHOR',
                '@CREATION_DATE',
            ],
            loading: false,
            fieldList: [],
        };
    },
    methods: {
        async edit(mask, contentTypeId) {
            this.loading = true;
            this.mask = mask;
            this.show();
            await this.getFields(contentTypeId);
            this.loading = false;
        },
        async getFields(contentTypeId) {
            const fields = await ContentTypeService.getFields([contentTypeId]);
            this.fieldList = fields.map(function(dto) {
                return new ContentTypeField(dto);
            });
        },
        save() {
            this.$emit('on-mask-saved', this.mask);
            this.hide();
        },
        appendField(field) {
            var code = `#${field.code}#`;
            this.mask += code;
        },
        appendOperator(op) {
            this.mask += op;
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>